import { t as isPlainObject } from "./isPlainObject-BxsT8_t2.js";
// src/utils/readJwtClaims.ts
let warnedUnreadable = false;
/**
* A JWT's payload claims, read without verifying the signature; `null` when it is not a readable JWT.
*
* - Decodes with `atob`, so it runs in a browser and in Node.
* - An unreadable payload is logged once per process, not on every call.
*/
const readJwtClaims = (token) => {
	const segments = token.split(".");
	const payload = segments[1];
	if (segments.length !== 3 || !payload) return null;
	const base64 = payload.replaceAll("-", "+").replaceAll("_", "/");
	const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "=");
	try {
		const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
		const claims = JSON.parse(new TextDecoder().decode(bytes));
		return isPlainObject(claims) ? claims : null;
	} catch (error) {
		if (!warnedUnreadable) console.warn("[api-client] a JWT payload is not base64url JSON", error);
		warnedUnreadable = true;
		return null;
	}
};
export { readJwtClaims as t };

//# sourceMappingURL=readJwtClaims-CMZ3cNC_.js.map